/* jshint undef: true, unused: true */

var HiddenWithText = require('./fobu-components/fobu-component-hiddenwithtext'),
    Multicolumn = require('./fobu-components/fobu-component-multicolumn'),
    Combo = require('./fobu-components/fobu-component-combo'),
    Button = require('./fobu-components/fobu-component-button'),
    Select = require('./fobu-components/fobu-component-select'),
    InputWithButton = require('./fobu-components/fobu-component-inputwithbutton'),
    Autocomplete = require('./fobu-components/fobu-component-autocomplete'),
    Typeahead = require('./fobu-components/fobu-component-typeahead'),
    Checkbox = require('./fobu-components/fobu-component-checkbox'),
    DateInput = require('./fobu-components/fobu-component-date');

module.exports = function components() {
  var components = {
    'hiddenwithtext'  : HiddenWithText,
    'multicolumn'     : Multicolumn,
    'combo'           : Combo,
    'button'          : Button,
    'select'          : Select,
    'inputwithbutton' : InputWithButton,
    'autocomplete'    : Autocomplete,
    'typeahead'       : Typeahead,
    'checkbox'        : Checkbox,
    'date'            : DateInput
  };

  return components;
};
